module.exports = __webpack_public_path__ + "assets/aaf806528a12a76220a2c4cff90e9cd5.mp3";